import React from "react"
import { Link } from "react-router-dom"
import { UncontrolledTooltip } from "reactstrap"

const ActionColumns = ({
  enableEdit,
  enableDelete,
  enableDetail,
  enableDocumentLink,
  documentLink,
  editRoute,
  onClickDelete,
  onClickDetail,
  data,
  enableAccept,
  onAcceptClick,
  disabled,
  disabledMessage,
}) => {
  const uniqueId = data?.id || 32;
  
  return (
    <div className="d-flex gap-3 align-items-center">
      {disabled && (
        <>
          <i
            className="mdi mdi-lock font-size-18 text-warning"
            id={`locktooltip-${uniqueId}`}
            style={{ cursor: 'default' }}
          />
          <UncontrolledTooltip placement="top" target={`locktooltip-${uniqueId}`}>
            {disabledMessage || "Locked due to pending transfer"}
          </UncontrolledTooltip>
        </>
      )}
      {enableDetail && (
        <Link
          to="#"
          className="text-info"
          onClick={e => {
            e.preventDefault()
            onClickDetail(data)
          }}
        >
          <i
            className="mdi mdi-format-list-bulleted font-size-18"
            id={`detailtooltip-${uniqueId}`}
          />
          <UncontrolledTooltip placement="top" target={`detailtooltip-${uniqueId}`}>
            Details
          </UncontrolledTooltip>
        </Link>
      )}

      {enableDocumentLink && (
        <a
          href={documentLink ? documentLink : ""}
          target="_blank"
          rel="noreferrer"
          download={true}
          className="text-info"
        >
          <i className="bx bx-link font-size-18" id={`documenttooltip-${uniqueId}`} />
          <UncontrolledTooltip placement="top" target={`documenttooltip-${uniqueId}`}>
            Show Document
          </UncontrolledTooltip>
        </a>
      )}

      {enableEdit && (
        <Link 
          to={editRoute && editRoute} 
          className={disabled ? "text-muted" : "text-success"}
          onClick={e => {
            if (disabled) {
              e.preventDefault()
            }
          }}
          style={disabled ? { cursor: 'not-allowed', opacity: 0.5 } : {}}
        >
          <i className="mdi mdi-pencil font-size-18" id={`edittooltip-${uniqueId}`} />
          <UncontrolledTooltip placement="top" target={`edittooltip-${uniqueId}`}>
            {disabled ? disabledMessage || "Cannot edit - locked due to pending transfer" : "Edit"}
          </UncontrolledTooltip>
        </Link>
      )}
      {enableDelete && (
        <Link
          to="#"
          className={disabled ? "text-muted" : "text-danger"}
          onClick={e => {
            e.preventDefault()
            if (!disabled && onClickDelete) {
              onClickDelete(data)
            }
          }}
          style={disabled ? { cursor: 'not-allowed', opacity: 0.5 } : {}}
        >
          <i className="mdi mdi-delete font-size-18" id={`deletetooltip-${uniqueId}`} />
          <UncontrolledTooltip placement="top" target={`deletetooltip-${uniqueId}`}>
            {disabled ? disabledMessage || "Cannot delete - locked due to pending transfer" : "Delete"}
          </UncontrolledTooltip>
        </Link>
      )}
      {enableAccept && (
        <Link
          to="#"
          className="text-success"
          onClick={e => {
            e.preventDefault()
            onAcceptClick(data)
          }}
        >
          <i className="mdi mdi-check font-size-18" id={`accepttooltip-${uniqueId}`} />
          <UncontrolledTooltip placement="top" target={`accepttooltip-${uniqueId}`}>
            Accept
          </UncontrolledTooltip>
        </Link>
      )}
    </div>
  )
}

export default ActionColumns
